import axios from 'axios';

export const validateAuthToken = async (
  authToken: string,
): Promise<{ isValid: boolean; isReplacementSent?: boolean }> => {
  const baseUrl = process.env.REACT_APP_API_URL as string;
  try {
    const response = await axios.post(
      `${baseUrl}users/token`,
      { authToken: authToken },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      },
    );
    return { isValid: response.status === 200 };
  } catch (err: unknown) {
    const error = err as { response?: { status: number } };
    if (error.response?.status === 410) {
      return { isValid: false, isReplacementSent: true };
    }
    return { isValid: false };
  }
};
